import { BenchmarkingRequestParams, useAnalyticsApi } from '@/hooks'
import { useTranslation } from 'react-i18next'
import { Dropdown } from '@/components/common/Dropdown/Dropdown'
import { Button, Icon } from '@/components/atoms'
import { MenuItem } from '@/components/common/MenuItem/MenuItem'
import { useState } from 'react'
import useToastStore from '@/stores/useToastStore/useToastStore'

export const BenchmarkingExportDropdown: React.FC<{
    filters: BenchmarkingRequestParams
}> = ({ filters }) => {
    const { t } = useTranslation('translations')
    const [isOpen, setIsOpen] = useState(false)
    const addAlert = useToastStore((state) => state.addAlert)

    const { useBenchmarkingQuery } = useAnalyticsApi()
    const { data, downloadXlsx, isError, isLoading, isFetching } =
        useBenchmarkingQuery(filters)

    return (
        <Dropdown
            isOpen={isOpen}
            onClick={(event) => {
                event.preventDefault()
                event.stopPropagation()
                setIsOpen(!isOpen)
            }}
            name="benchmarking-export-dropdown"
            buttonProps={{
                name: 'benchmarking-summary-dropdown',
                children: (
                    <>
                        {t('common.export_report_dropdown.label')}
                        <Icon size="small" name="keyboard_arrow_down" />
                    </>
                ),
                variant: 'outlinePrimary',
                size: 'large',
                disabled: !data?.length || isFetching || isError || isLoading,
            }}
            buttonComponent={Button}
            horizontalAlign="right"
            dropdownClassname="py-3 !min-w-[auto]"
        >
            <MenuItem
                path="/"
                variant="ghost"
                label={t('common.export_report_dropdown.options.xls')}
                render={({ renderContents }) => (
                    <button
                        className="group w-full outline-none"
                        onClick={() => {
                            addAlert({
                                variant: 'success',
                                title: t(
                                    'reporting.export_report.success_toast.title'
                                ),
                                description: t(
                                    'reporting.export_report.success_toast.description'
                                ),
                            })

                            setIsOpen(false)

                            downloadXlsx().catch(() => {
                                addAlert({
                                    variant: 'error',
                                    title: t(
                                        'reporting.export_report.error_toast.title'
                                    ),
                                    description: t(
                                        'reporting.export_report.error_toast.description'
                                    ),
                                })
                            })
                        }}
                        data-testid="export-benchmarking-excel-button"
                    >
                        {renderContents()}
                    </button>
                )}
            />
        </Dropdown>
    )
}
